// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      ::ng-deep mat-expansion-panel-header .mat-expansion-indicator {
        display: none;
      }
      ::ng-deep mat-icon {
        color: white !important;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-emergency-response/ert-emergency-response-addmrs/ert-emergency-response-addmrs-create/ert-emergency-response-addmrs-create.component.ts"],"names":[],"mappings":";MACM;QACE,aAAa;MACf;MACA;QACE,uBAAuB;MACzB","sourcesContent":["\n      ::ng-deep mat-expansion-panel-header .mat-expansion-indicator {\n        display: none;\n      }\n      ::ng-deep mat-icon {\n        color: white !important;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
